import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Home from './components/Home';
import Home2 from './components/Home2';
import Home3 from './components/Home3';
import Search from './components/Search.js';
import Search2 from './components/Search2.js';
import Search3 from './components/Search3.js';
import GiveSubscription from './components/GiveSubscription.js';
import GiveSubscription2 from './components/GiveSubscription2.js';
import GiveSubscription3 from './components/GiveSubscription3.js';
import TakeSubscription from './components/TakeSubscription';
import TakeSubscription2 from './components/TakeSubscription2';
import TakeSubscription3 from './components/TakeSubscription3';
import Ban from './components/Ban.js';
import Ban2 from './components/Ban2.js';
import Ban3 from './components/Ban3.js';
import Unban from './components/Unban';
import Unban2 from './components/Unban2';
import Unban3 from './components/Unban3';
import Newsletter from './components/Newsletter';
import Newsletter2 from './components/Newsletter2';
import Newsletter3 from './components/Newsletter3';
import Givetoken from './components/Givetoken';
import Givetoken2 from './components/Givetoken2';
import Givetoken3 from './components/Givetoken3';
import Taketoken from './components/Taketoken.js';
import Taketoken2 from './components/Taketoken2.js';
import Taketoken3 from './components/Taketoken3.js';
import Messages from './components/Messages.js';
import Dialog from './components/Dialog';
import Payment from './components/Payment.js';
import Partner from './components/Partner.js';
import Partner2 from './components/Partner2.js';
import Analytics from './components/Analytics.js';
import Analytics2 from './components/Analytics2.js';
import Analytics3 from './components/Analytics3.js';

const ProtectedRoute = ({ element }) => {
  const [authorized, setAuthorized] = useState(null);
  const location = useLocation();

  useEffect(() => {
    // Проверка только если не страница Payment
    if (location.pathname !== '/') {
      const pass = prompt('Введите пароль для доступа:');
      if (pass === '321s') {
        setAuthorized(true);
      } else {
        alert('Неверный пароль!');
        setAuthorized(false);
      }
    } else {
      setAuthorized(true);
    }
  }, [location.pathname]);

  if (authorized === null) return null;
  if (!authorized) return <div>Доступ запрещён</div>;
  return element;
};

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Payment />} />
        <Route path="/admin" element={<ProtectedRoute element={<Home />} />} />
        <Route path="/admin2" element={<ProtectedRoute element={<Home2 />} />} />
        <Route path="/admin3" element={<ProtectedRoute element={<Home3 />} />} />
        
        <Route path="/admin/search" element={<ProtectedRoute element={<Search />} />} />
        <Route path="/admin2/search" element={<ProtectedRoute element={<Search2 />} />} />
        <Route path="/admin3/search" element={<ProtectedRoute element={<Search3 />} />} />

        <Route path="/admin/give-subscription" element={<ProtectedRoute element={<GiveSubscription />} />} />
        <Route path="/admin2/give-subscription" element={<ProtectedRoute element={<GiveSubscription2 />} />} />
        <Route path="/admin3/give-subscription" element={<ProtectedRoute element={<GiveSubscription3 />} />} />

        <Route path="/admin/take-subscription" element={<ProtectedRoute element={<TakeSubscription />} />} />
        <Route path="/admin2/take-subscription" element={<ProtectedRoute element={<TakeSubscription2 />} />} />
        <Route path="/admin3/take-subscription" element={<ProtectedRoute element={<TakeSubscription3 />} />} />

        <Route path="/admin/ban" element={<ProtectedRoute element={<Ban />} />} />
        <Route path="/admin2/ban" element={<ProtectedRoute element={<Ban2 />} />} />
        <Route path="/admin3/ban" element={<ProtectedRoute element={<Ban3 />} />} />

        <Route path="/admin3/analytics" element={<ProtectedRoute element={<Analytics3 />} />} />
        <Route path="/admin2/analytics" element={<ProtectedRoute element={<Analytics2 />} />} />
        <Route path="/admin/analytics" element={<ProtectedRoute element={<Analytics />} />} />

        <Route path="/admin/message" element={<ProtectedRoute element={<Messages />} />} />
        <Route path="/admin/unban" element={<ProtectedRoute element={<Unban />} />} />
        <Route path="/admin2/unban" element={<ProtectedRoute element={<Unban2 />} />} />
        <Route path="/admin3/unban" element={<ProtectedRoute element={<Unban3 />} />} />

        <Route path="/admin/givetoken" element={<ProtectedRoute element={<Givetoken />} />} />
        <Route path="/admin2/givetoken" element={<ProtectedRoute element={<Givetoken2 />} />} />
        <Route path="/admin3/givetoken" element={<ProtectedRoute element={<Givetoken3 />} />} />

        <Route path="/admin/partner" element={<ProtectedRoute element={<Partner />} />} />
        <Route path="/admin2/partner" element={<ProtectedRoute element={<Partner2 />} />} />

        <Route path="/admin/taketoken" element={<ProtectedRoute element={<Taketoken />} />} />
        <Route path="/admin2/taketoken" element={<ProtectedRoute element={<Taketoken2 />} />} />
        <Route path="/admin3/taketoken" element={<ProtectedRoute element={<Taketoken3 />} />} />

        <Route path="/admin/newsletter" element={<ProtectedRoute element={<Newsletter />} />} />
        <Route path="/admin2/newsletter" element={<ProtectedRoute element={<Newsletter2 />} />} />
        <Route path="/admin3/newsletter" element={<ProtectedRoute element={<Newsletter3 />} />} />

        <Route path="/admin/dialog/:id" element={<ProtectedRoute element={<Dialog />} />} />
      </Routes>
    </Router>
  );
};

export default App;
